// RemindPopover.jsx
import React, { memo } from 'react';
import Popover from '@mui/material/Popover';
import RemindCard from './RemindCard';

const RemindPopover = ({ anchorEl, onClose }) =>
{
	const open = Boolean(anchorEl);

	return (
		<Popover
			open={open}
			anchorEl={anchorEl}
			onClose={onClose}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			transformOrigin={{ vertical: 'top', horizontal: 'center' }}
			slotProps={{
				paper : {
					sx : {
						borderRadius : 2, // 13px → 2 * 8 = 16px approx, using spacing unit
						boxShadow    : '8px 8px 8px #0000001A'
					}
				}
			}}
		>
			<RemindCard />
		</Popover>
	);
};

export default memo(RemindPopover);
